@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

@for (contact of attributes.contacts; track contact) {
  <app-contact
    [contact]="contact"
    [type]="attributes.color === 'blue' ? 'bar' : 'floating'"
  ></app-contact>
}
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
